import { Upload, FileText, Send } from "lucide-react";

const STEPS = [
  { step: "01", icon: Upload, title: "Share Your Profile", desc: "Tell us your target role, experience, and share your LinkedIn." },
  { step: "02", icon: FileText, title: "We Find Jobs", desc: "Our team finds 20-50 relevant job openings matching your criteria." },
  { step: "03", icon: Send, title: "Get Ready-to-Apply Kit", desc: "Receive job links, cover letters, and application materials via email." },
];

export function HowItWorks() {
  return (
    <section className="bg-zinc-50 border-b border-zinc-200">
      <div className="max-w-6xl mx-auto px-6 py-16">
        <div className="text-center mb-12">
          <h2
            className="text-2xl sm:text-3xl font-bold tracking-tight text-zinc-900"
            style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}
          >
            How It Works
          </h2>
        </div>
        <div className="grid md:grid-cols-3 gap-8">
          {STEPS.map((item) => (
            <div key={item.step} className="bg-white p-8 border border-zinc-200">
              <div className="flex items-center gap-4 mb-4">
                <span className="text-4xl font-black text-zinc-200">{item.step}</span>
                <item.icon className="w-8 h-8 text-[#002FA7]" />
              </div>
              <h3 className="text-xl font-semibold text-zinc-900 mb-2">{item.title}</h3>
              <p className="text-zinc-600">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
